import { motion } from "framer-motion";
import ScrollAnimation from "../components/animations/ScrollAnimation";
import ParallaxBg from "../components/animations/ParallaxBg";
import { useTranslation } from 'react-i18next';
import { useSectionT } from "../contexts/PageVariantContext";

const Testimonials = () => {
    const { t } = useTranslation();
    const sectionT = useSectionT();
    const testimonials = t(sectionT('testimonials.items'), { returnObjects: true }) as Array<{
        content: string;
        author: string;
        position: string;
        initials: string;
    }>;

    return (
        <ParallaxBg className="py-20 text-gray-900">
            <div className="container mx-auto px-4 sm:px-6 lg:px-8">
                <ScrollAnimation>
                    <div className="text-center mb-16">
                        <h2 className="text-3xl md:text-4xl font-poppins font-bold mb-4">
                            {t(sectionT('testimonials.title'))}
                        </h2>
                        <div className="w-20 h-1 bg-accent-500 mx-auto mb-6"></div>
                        <p className="text-lg text-gray-500 max-w-2xl mx-auto">
                            {t(sectionT('testimonials.subtitle'))}
                        </p>
                    </div>
                </ScrollAnimation>

                <div className="grid md:grid-cols-3 gap-8">
                    {testimonials.map((testimonial, index) => (
                        <ScrollAnimation key={index} delay={index * 0.2}>
                            <motion.div
                                className="bg-white backdrop-blur-md p-8 rounded-xl border border-gray-900/10"
                                whileHover={{ y: -10 }}
                                transition={{ duration: 0.3 }}
                            >
                                <div className="flex items-center mb-4">
                                    {[...Array(5)].map((_, i) => (
                                        <svg
                                            key={i}
                                            className="w-5 h-5 text-yellow-400 mr-1"
                                            fill="currentColor"
                                            viewBox="0 0 20 20"
                                        >
                                            <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
                                        </svg>
                                    ))}
                                </div>
                                <p className="mb-4 italic">{testimonial.content}</p>
                                <div className="flex items-center">
                                    <div className="w-12 h-12 rounded-full bg-accent-500 flex items-center justify-center mr-4">
                                        <span className="font-bold text-gray">
                                            {testimonial.initials}
                                        </span>
                                    </div>
                                    <div>
                                        <p className="font-semibold">{testimonial.author}</p>
                                        <p className="text-sm text-gray-500">
                                            {testimonial.position}
                                        </p>
                                    </div>
                                </div>
                            </motion.div>
                        </ScrollAnimation>
                    ))}
                </div>
            </div>
        </ParallaxBg>
    );
};

export default Testimonials;
